export const solutionMosaic = {
  intro: {
    title: '解决方案',
    en: 'Solution',
    desc: '围绕农业、停车、物流三大高频场景，华辉数智以 AIoT 感知终端与云平台为底座，把复杂的现场运行转化为可感知、可运营、可持续迭代的数字能力，帮助县域与城市构建一套真正落地的场景化解决方案。',
  },
  items: [
    {
      name: '智慧农业',
      en: 'Smart Agriculture',
      tagline: '精准种植 · 农田数字化',
      href: '/solutions/smart-agriculture',
      image:
        'https://readdy.ai/api/search-image?query=Wide%20aerial%20view%20of%20lush%20green%20terraced%20farmland%20with%20neat%20crop%20rows%2C%20small%20IoT%20sensor%20poles%20and%20a%20drone%20flying%20above%20the%20field%20collecting%20data%2C%20warm%20natural%20sunlight%2C%20clear%20sky%2C%20realistic%20agricultural%20photography%2C%20high%20detail&width=1200&height=600&seq=home-mosaic-agri-01&orientation=landscape',
    },
    {
      name: '自由流停车',
      en: 'Smart Parking',
      tagline: '不停车通行 · 全场景一张网',
      href: '/solutions/smart-parking',
      image:
        'https://readdy.ai/api/search-image?query=Realistic%20city%20street%20parking%20scene%20with%20parked%20cars%20along%20the%20roadside%2C%20digital%20parking%20guidance%20screen%20and%20license%20plate%20recognition%20camera%20above%20the%20lane%2C%20soft%20daylight%2C%20modern%20urban%20environment%2C%20high%20detail&width=1200&height=600&seq=home-mosaic-parking-02&orientation=landscape',
    },
    {
      name: '智慧物流',
      en: 'Smart Logistics',
      tagline: '仓储运输 · 配送数字化',
      href: '/solutions/smart-logistics',
      image:
        'https://readdy.ai/api/search-image?query=Modern%20logistics%20distribution%20center%20with%20rows%20of%20cargo%20trucks%20at%20loading%20docks%2C%20stacked%20pallets%20and%20warehouse%20workers%20moving%20goods%2C%20bright%20daylight%2C%20realistic%20industrial%20photography%2C%20high%20detail&width=1200&height=600&seq=home-mosaic-logistics-03&orientation=landscape',
    },
  ],
};